import React from 'react';

// Vitality brand mark — blue gradient rounded square with a subtle pill/cross glyph
const Logo = ({ size = 40, withText = true, subtitle = false, light = false }) => {
  return (
    <div className="flex items-center gap-3 select-none">
      <div
        className="relative flex items-center justify-center rounded-xl shadow-sm shrink-0"
        style={{
          width: size,
          height: size,
          background: 'linear-gradient(150deg, #3b82f6 0%, #22d3ee 100%)',
        }}
      >
        <span
          className="font-display font-bold text-white leading-none"
          style={{ fontSize: size * 0.3 }}
        >
          Vitality
        </span>
      </div>
      {withText && (
        <div className="leading-tight">
          <div className={`font-display font-bold tracking-tight ${light ? 'text-white' : 'text-slate-900'}`} style={{ fontSize: subtitle ? 17 : 20 }}>
            Vitality {subtitle ? 'Pharmacy' : 'Pharmacy Software'}
          </div>
          {subtitle && (
            <div className={`text-[11px] font-semibold tracking-[0.18em] ${light ? 'text-slate-300' : 'text-slate-400'}`}>
              SOFTWARE
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
